import type { APIConfigurationOverride } from '@smartapps-poll/web-common'
import type { EnvOptions } from '@vocdoni/sdk'

export const apiOverrides = (noProxy: boolean): APIConfigurationOverride[] => [
  {
    contextDomain: 'googleusercontent.com',
    url: process.env.REACT_APP_DEBUG_MODE === 'true'
      ? 'https://d9p1mri6vf2iv.cloudfront.net/api'
      : 'https://newbelarus-voting.com/api',
    fireproxy: !noProxy,
    vocdoni: {
      env: (process.env.REACT_APP_DEBUG_MODE === 'true' ? 'stg' : 'prod') as EnvOptions,
      fireproxy: !noProxy
    },
    baseUrl: process.env.REACT_APP_DEBUG_MODE === 'true'
      ? 'https://storage.cloud.google.com/newbealrus-voting-hide/index.html'
      : 'https://storage.cloud.google.com/nbvoting/index.html'
  },
  {
    contextDomain: 'storage.googleapis.com',
    url: process.env.REACT_APP_DEBUG_MODE === 'true'
      ? 'https://d9p1mri6vf2iv.cloudfront.net/api'
      : 'https://newbelarus-voting.com/api',
    fireproxy: !noProxy,
    vocdoni: {
      env: (process.env.REACT_APP_DEBUG_MODE === 'true' ? 'stg' : 'prod') as EnvOptions,
      fireproxy: !noProxy
    },
    baseUrl: process.env.REACT_APP_DEBUG_MODE === 'true'
      ? 'https://storage.googleapis.com/newbealrus-voting-hide/index.html'
      : 'https://storage.googleapis.com/nbvoting/index.html'
  },
  {
    contextDomain: 'localhost',
    url: 'http://localhost/stage-api',
    fireproxy: false,
    vocdoni: {
      env: (process.env.REACT_APP_VOCDONI_ENV ?? 'dev') as EnvOptions,
      fireproxy: false
    },
    baseUrl: 'http://localhost'
  },
  {
    contextDomain: 'nbpoll.owlmeans.local',
    url: noProxy ? 'https://api.nbpoll.owlmeans.local' : 'https://owlmeans.ngrok.dev',
    fireproxy: !noProxy,
    vocdoni: {
      env: (process.env.REACT_APP_VOCDONI_ENV ?? 'dev') as EnvOptions,
      fireproxy: !noProxy
    },
    baseUrl: noProxy ? 'https://nbpoll.owlmeans.local' : 'https://owlmeansnb.ngrok.app'
  },
  {
    contextDomain: 'd9p1mri6vf2iv.cloudfront.net',
    url: 'https://d9p1mri6vf2iv.cloudfront.net/api',
    fireproxy: !noProxy,
    vocdoni: {
      env: (process.env.REACT_APP_VOCDONI_ENV ?? 'stg') as EnvOptions,
      fireproxy: !noProxy
    },
    baseUrl: 'https://d9p1mri6vf2iv.cloudfront.net'
  },
  {
    contextDomain: 'newbelarus-voting.com',
    url: 'https://newbelarus-voting.com/api',
    fireproxy: !noProxy,
    vocdoni: {
      env: 'prod' as EnvOptions,
      fireproxy: !noProxy
    },
    baseUrl: 'https://newbelarus-voting.com'
  }
]
